<template>
  <el-dialog :title="$t('shopTypeManage.add')" :visible.sync="dialogVisible" width="50%" @close="resetForm">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item :label="$t('shopTypeManage.shopType')" prop="typeName">
        <el-input v-model="formData.typeName" :placeholder="$t('shopTypeManage.inputTypeNameRequired')" />
      </el-form-item>

      <el-form-item :label="$t('shopTypeManage.isShow')" prop="isShow">
        <el-select v-model="formData.isShow" :placeholder="$t('shopTypeManage.selectIsShowRequired')"
          style="width:100%">
          <el-option :label="$t('shopTypeManage.yes')" value="Y" />
          <el-option :label="$t('shopTypeManage.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('shopTypeManage.isDefault')" prop="isDefault">
        <el-select v-model="formData.isDefault" :placeholder="$t('shopTypeManage.selectIsDefaultRequired')"
          style="width:100%">
          <el-option :label="$t('shopTypeManage.custom')" value="F" />
          <el-option :label="$t('shopTypeManage.default')" value="T" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('shopTypeManage.seq')" prop="seq">
        <el-input v-model="formData.seq" :placeholder="$t('shopTypeManage.inputSeqRequired')" />
      </el-form-item>

      <el-form-item :label="$t('shopTypeManage.remark')">
        <el-input v-model="formData.remark" type="textarea" :placeholder="$t('shopTypeManage.inputRemarkOptional')" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="submitForm">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveShopType } from '@/api/admin/shopTypeApi'

export default {
  name: 'AddShopType',
  data() {
    return {
      dialogVisible: false,
      formData: {
        typeName: '',
        isShow: '',
        isDefault: '',
        seq: '',
        remark: ''
      },
      rules: {
        typeName: [
          { required: true, message: this.$t('shopTypeManage.typeNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('shopTypeManage.typeNameTooLong'), trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: this.$t('shopTypeManage.isShowRequired'), trigger: 'change' }
        ],
        isDefault: [
          { required: true, message: this.$t('shopTypeManage.isDefaultRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('shopTypeManage.seqRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('shopTypeManage.seqNotNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        typeName: '',
        isShow: '',
        isDefault: '',
        seq: '',
        remark: ''
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const {code,msg} = await saveShopType(this.formData)
            if(code != 0){
              this.$message.error(msg)
              return
            }
            this.$message.success(this.$t('shopTypeManage.addSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>